import {
  Accordion,
  ActionIcon,
  Avatar,
  Box,
  Button,
  Drawer,
  Flex,
  Group,
  Radio,
  Select,
  Text,
  Textarea,
  rem,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { IoIosArrowDown } from "react-icons/io";
import { useSelector } from "react-redux";
import { decrypt, showInfo } from "../../utils";
import useStyles from "./style";
import moment from "moment";
import "moment-timezone";
import {
  createMar,
  getMar,
  recordResponse,
  updateMedicationAdministration,
} from "../../services";
import { getAllPatientsModal } from "../../services/patient";
import DeleteComponent from "../MedicationModal/DeleteComponent";
import { IconChevronDown, IconClock, IconPill } from "@tabler/icons-react";
import { DateInput, DatePickerInput, TimeInput } from "@mantine/dates";
import dayjs from "dayjs";
import { TiMinus } from "react-icons/ti";
import { FaPlus } from "react-icons/fa6";
import { LuCalendar } from "react-icons/lu";
import { useMediaQuery } from "@mantine/hooks";

// Helper to resolve PRN status
const resolveMedTypePRN = (medType) => {
  if (!medType) return false;
  if (typeof medType === "string") {
    if (medType.toUpperCase() === "PRN") return true;
    try {
      return resolveMedTypePRN(JSON.parse(medType));
    } catch (e) {
      return false;
    }
  }
  if (Array.isArray(medType)) {
    if (medType.length === 0) return false;
    const last = medType[medType.length - 1];
    return resolveMedTypePRN(last?.status);
  }
  return false;
};

const PRNMedicationModal = forwardRef(
  ({ opened, onclose, data, isNew: isNewPRN, date }, ref) => {
    const { classes } = useStyles();
    const isMobileScreen = useMediaQuery("(max-width: 600px)");
    const { staff } = useSelector((state) => state?.staff);

    const medicines =
      data?.form3?.length > 0
        ? data?.form3
            ?.filter(
              (v) => resolveMedTypePRN(v?.medicationType) && !v?.discontinued,
            )
            ?.map((value) => ({
              value: value?.id,
              label: value?.medicationName,
            })) || []
        : [];
    const prnMedObjects =
      data?.form3?.filter(
        (v) => resolveMedTypePRN(v?.medicationType) && !v?.discontinued,
      ) || [];
    const [isNew, setIsNew] = useState(isNewPRN);
    const [loading, setLoading] = useState(false);
    const [loadingResponse, setLoadingResponse] = useState(false);
    const { selectedClient } = useSelector((state) => state.mar);
    const [selectedMedicine, setSelectedMedicine] = useState(null);
    const { profile } = useSelector((state) => state.profile);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    let userid = profile?.user?.id;
    let userType = profile?.user?.type;
    const _medicationType = data?.medicationType;
    const _upcoming = "upcoming";
    const [state, setState] = useState(null);
    console.log("🚀 ~ stateprnnnnn:", state);
    const [selectedStaff, setSelectedStaff] = useState();
    const { allSignature, signature } = useSelector((state) => {
      return state?.signature;
    });
    const [slotDate, setSlotDate] = useState(date || undefined);
    const [prnAdministeredAt, setPrnAdministeredAt] = useState(null);
    // const [populateStaff, setPopulateStaff] = useState();
    // useEffect(() => {
    //   const staffOptions =
    //     staff?.staffs?.map((item) => ({
    //       value: item?.id,
    //       label: item?.name,
    //     })) || [];

    //   const defaultStaff = profile?.user?.id
    //     ? {
    //         value: profile?.user?.id,
    //         label: profile?.user?.name,
    //       }
    //     : null;

    //   // Add default staff if not already in the list
    //   const isDefaultInList = staffOptions.some(
    //     (opt) => opt.value === defaultStaff?.value
    //   );
    //   const finalOptions =
    //     defaultStaff && !isDefaultInList
    //       ? [defaultStaff, ...staffOptions]
    //       : staffOptions;

    //   setPopulateStaff(finalOptions);
    //   setSelectedStaff(defaultStaff?.value || null);
    // }, [staff, profile]);

    const assignedStaffIds = selectedClient?.staff
      ?.filter((s) => s?.isAssign === true)
      ?.map((s) => s?.staffId);

    const populateStaff = staff?.staffs
      ?.filter((staff) => assignedStaffIds?.includes(staff?.id))
      ?.map((staff) => ({
        label: staff?.name,
        value: staff?.id,
      }));

    useEffect(() => {
      if (isNewPRN) {
        setIsNew(true);
        setSelectedMedicine(null);
      }
    }, [opened, isNewPRN]);

    const form = useForm({
      initialValues: {
        medicine: "",
        reason: "",
        comments: "",
        wasEffective: "",
        staff: data?.staff?.name,
        date: new Date(),
        time: moment().format("HH:mm"),
        scheduleDate: "",
      },
      validate: {
        medicine: (value) => (value ? null : "Please select a PRN medicine"),
      },
    });
    const form2 = useForm({
      initialValues: {
        wasEffective: "",
      },
      validate: {
        wasEffective: (value) => (value ? null : "Required"),
      },
    });

    const handleAdminBy = async (values) => {
      // console.log('values',values);

      const date = moment(values?.date);
      const time = moment(values?.time, "hh:mm A");
      const mergedDateTime = moment(date).set({
        hour: time.hours(),
        minute: time.minutes(),
        second: 0,
      });
      const obj = {
        marId: state?._id,
        staff: values?.staff,
        createdAt: mergedDateTime?.toISOString(),
        administeredAt: mergedDateTime?.toISOString(),
        // matchDate tells the backend which entry to find (the OLD date before editing)
        matchDate: prnAdministeredAt
          ? moment(prnAdministeredAt).utc().format("YYYY-MM-DD")
          : undefined,
        medicationType: "PRN",
      };
      setBtnLoading(true);
      await updateMedicationAdministration(obj);
      getMar(localStorage.getItem("calendar_date"), selectedClient?.id);
      form.reset();
      setIsEditOpen(false);
      setSelectedStaff();
      onclose();
      setBtnLoading(false);
    };

    useImperativeHandle(ref, () => ({
      openView: (data, date) => {
        setIsNew(false);
        setState(data);
        setSlotDate(date);
        setSelectedMedicine(data?.form3);
        form.setFieldValue("medicine", data?.form3?.id || data?.medicationId || "");
        form.setFieldValue("quantity", data?.dosage);
        form.setFieldValue("reason", data?.reason);
        form.setFieldValue("otherReason", data?.otherReason);
        form.setFieldValue("comments", data?.comments);
        form2.setFieldValue(
          "wasEffective",
          data?.medicationType?.[0]?.wasMedicineEffective,
        );
        // Administration Form
        form.setFieldValue("staff", data?.staff?.id);
        form.setFieldValue("date", new Date());
        form.setFieldValue("time", moment().format("HH:mm"));

        // Resolve administeredAt from the matching medicationType entry
        const targetDateStr = date ? moment(date).format("YYYY-MM-DD") : null;
        let resolvedAt = data?.createdAt;
        if (targetDateStr && Array.isArray(data?.medicationType)) {
          const match = data.medicationType
            .filter(
              (m) =>
                m?.date &&
                moment(m.date).format("YYYY-MM-DD") === targetDateStr,
            )
            .at(-1);
          if (match)
            resolvedAt = match.administeredAt || match.date || data?.createdAt;
        }
        setPrnAdministeredAt(resolvedAt);
      },
    }));

    const onMedicineChange = (med) => {
      let medicine = data?.form3?.find((v) => v?.id === med);
      form.setFieldValue("medicine", med);
      setSelectedMedicine(medicine);
      form.setFieldValue(
        "quantity",
        String(medicine?.medicationadministered || "0"),
      );
    };
    const onSave = async (values) => {
      if (Number(values?.quantity) > 0) {
        let obj = {
          client: selectedClient?.id,
          // date: form.values?.scheduleDate || moment().toISOString(),
          date: form.values?.createdAt || moment().toISOString(),
          createdAt: form.values?.createdAt || moment().toISOString(),
          medicationId: selectedMedicine?.id,
          medicationType: "PRN",
          staff: selectedStaff || userid,
          comments: values?.comments,
          reason: values?.reason,
          medicationName: selectedMedicine?.medicationName,
        };

        if (values?.reason === "Other") {
          obj = { ...obj, otherReason: values?.otherReason };
        }

        const dosage = Number(values?.quantity);

        const payload = {
          ...obj,
          dosage,
        };
        setLoading(true);
        try {
          const success = await createMar(payload);
          if (success) {
            form.reset();
            setSelectedStaff();
            setSelectedMedicine(null);
            onclose();
            let calendar_view = localStorage.getItem("calendar_date");
            getMar(calendar_view, selectedClient?.id);
          }
        } catch (error) {
        } finally {
          setLoading(false);
        }
      } else {
        alert("Quantity is Required!");
      }
    };

    const onSavePress = async (values) => {
      if (values.wasEffective && state?._id) {
        let payload = {
          id: state?._id,
          wasMedicineEffective: values?.wasEffective,
          entryDate: state?.medicationType?.[0]?.date || state?.date,
        };
        setLoadingResponse(true);
        try {
          await recordResponse(payload, () => {
            setLoadingResponse(false);
            showInfo("Response has been recorded");
            form2.reset();
            onclose();
            const calendar_view = localStorage.getItem("calendar_date");
            getMar(calendar_view, selectedClient?.id);
          });
        } catch (error) {
        } finally {
          setLoadingResponse(false);
        }
      }
    };

    const timeRef = useRef();

    const selectedId =
      isEditOpen && userType !== "staff"
        ? form?.values?.staff
        : !isEditOpen && !isNew
          ? state?.staff?.id || state?.staff?._id?.toString()
          : data?.staff?.id || data?.staff?._id?.toString();
    const staffSignature = allSignature?.find(({ staff, admin }) => {
      const staffId = staff?._id?.toString() || staff?.id || staff;
      const adminId = admin?._id?.toString() || admin?.id || admin;
      return staffId === selectedId || adminId === selectedId;
    });

    // const staffSignature = allSignature?.find(({ staff, admin }) => {
    //   return (
    //     (staff  || (isEditOpen ? form?.values?.staff : data?.staff?.id)) ||
    //     (admin || (isEditOpen ? form?.values?.staff : data?.staff?.id))
    //   );
    // });

    return (
      <>
        {/* ── DRAWER: Administer new PRN ── */}
        <Drawer
          opened={opened && !!isNew}
          onClose={() => {
            onclose();
            setSelectedStaff();
            setSelectedMedicine(null);
            form.reset();
          }}
          closeOnClickOutside={false}
          withCloseButton={false}
          offset={8}
          size={690}
          sx={{
            ".mantine-Drawer-content": {
              background: "var(--app-surface)",
              borderTopLeftRadius: 16,
              borderBottomLeftRadius: 16,
            },
            ".mantine-Drawer-body": {
              padding: 0,
              height: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            },
          }}
          zIndex={2000}
          position="right"
          overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}
          shadow="md"
        >
          <div className={classes.drawerBody}>
            {/* Header */}
            <div className={classes.modalTopBar}>
              <div>
                <h3 className={classes.modalTitle}>
                  Administer PRN Medication
                </h3>
                <p className={classes.prnSubtitle}>
                  Record an as-needed administration outside the regular
                  schedule.
                </p>
              </div>
              <button
                type="button"
                className={classes.modalCloseBtn}
                onClick={() => {
                  onclose();
                  setSelectedStaff();
                  setSelectedMedicine(null);
                  form.reset();
                }}
              >
                ✕
              </button>
            </div>

            {/* Form — scrollable body + sticky footer */}
            <form
              onSubmit={form?.onSubmit((values) => onSave(values))}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <div className={classes.formBox}>
                <div className={classes.prnWrapper}>
                  {/* Client banner */}
                  <div className={classes.viewClientCard}>
                    <Flex align="center" gap={12}>
                      <Avatar
                        className={classes.clientAvatar}
                        src={decrypt(selectedClient?.imageurl) || ""}
                        alt="client"
                        radius="xl"
                        size={48}
                      />
                      <div>
                        <Text className={classes.clientName}>
                          {selectedClient?.name}
                        </Text>
                        <Text className={classes.clientId}>
                          {selectedClient?.id?.slice(0, 6)?.toLowerCase()}
                        </Text>
                      </div>
                    </Flex>
                  </div>

                  {/* ── PRN Medication Picker ── */}
                  <div style={{ marginBottom: 16 }}>
                    {!selectedMedicine && (
                      <Text
                        size="sm"
                        weight={600}
                        mb={10}
                        style={{ color: "var(--app-text)", fontFamily: "Inter" }}
                      >
                        Select a PRN medication
                      </Text>
                    )}

                    {!selectedMedicine ? (
                      /* Radio-card list */
                      prnMedObjects.length === 0 ? (
                        <div className={classes.prnEmptyState}>
                          No PRN medications found for this client.
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                          }}
                        >
                          {prnMedObjects.map((med) => (
                            <label
                              key={med.id}
                              className={classes.prnRadioCard}
                              style={{ cursor: "pointer" }}
                            >
                              <input
                                type="radio"
                                name="prn-med-pick"
                                style={{
                                  accentColor: "var(--app-primary)",
                                  width: 14,
                                  height: 14,
                                  flexShrink: 0,
                                }}
                                onChange={() => onMedicineChange(med.id)}
                              />
                              <div
                                className={
                                  med.isNarcotic === "Yes"
                                    ? classes.pillIconWrapNarcotic
                                    : classes.pillIconWrap
                                }
                              >
                                <IconPill size={14} />
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    flexWrap: "wrap",
                                    marginBottom: 2,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 600,
                                      color: "var(--app-text)",
                                      fontFamily: "Inter",
                                      lineHeight: 1.3,
                                    }}
                                  >
                                    {med.medicationName}
                                  </span>
                                  {med.dosage && (
                                    <span
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: "var(--app-text-muted)",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      {med.dosage}
                                      {med.unit || ""}
                                    </span>
                                  )}
                                  {med.isNarcotic === "Yes" && (
                                    <span
                                      style={{
                                        fontSize: 9,
                                        fontWeight: 700,
                                        padding: "1px 7px",
                                        background: "var(--app-tint-red)",
                                        color: "#B91C1C",
                                        border: "1px solid #FECACA",
                                        borderRadius: 999,
                                        letterSpacing: 0.4,
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      Narcotic
                                    </span>
                                  )}
                                  <span
                                    style={{
                                      fontSize: 9,
                                      fontWeight: 700,
                                      padding: "1px 7px",
                                      background: "var(--app-tint-purple)",
                                      color: "#6B21A8",
                                      border: "1px solid #E9D5FF",
                                      borderRadius: 999,
                                      letterSpacing: 0.4,
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    PRN
                                  </span>
                                </div>
                                <span
                                  style={{
                                    fontSize: 12,
                                    color: "var(--app-text-muted)",
                                    fontFamily: "Inter",
                                  }}
                                >
                                  {[med.ingestionMode, med.dosageForm]
                                    .filter(Boolean)
                                    .join(", ") || "—"}
                                  {med.medicineRemaining != null &&
                                  med.totalMedicine != null
                                    ? ` · ${med.medicineRemaining} of ${med.totalMedicine} remaining`
                                    : ""}
                                </span>
                              </div>
                            </label>
                          ))}
                        </div>
                      )
                    ) : (
                      /* Selected state */
                      <>
                        <Select
                          className={classes.inputStyle}
                          label="PRN medication"
                          placeholder="Select a different PRN medication"
                          data={medicines}
                          value={form.values.medicine}
                          onChange={onMedicineChange}
                          rightSection={<IconChevronDown size={16} />}
                          nothingFound="No PRN medicine found"
                          mb={8}
                        />

                        {/* Selected card */}
                        <div className={classes.prnSelectedCard}>
                          <div
                            className={
                              selectedMedicine.isNarcotic === "Yes"
                                ? classes.pillIconWrapNarcotic
                                : classes.pillIconWrap
                            }
                          >
                            <IconPill size={14} />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                flexWrap: "wrap",
                                marginBottom: 2,
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: "var(--app-text)",
                                  fontFamily: "Inter",
                                }}
                              >
                                {selectedMedicine.medicationName}
                              </span>
                              {selectedMedicine.dosage && (
                                <span
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: "var(--app-text-muted)",
                                    fontFamily: "Inter",
                                  }}
                                >
                                  {selectedMedicine.dosage}
                                  {selectedMedicine.unit || ""}
                                </span>
                              )}
                              {selectedMedicine.isNarcotic === "Yes" && (
                                <span
                                  style={{
                                    fontSize: 9,
                                    fontWeight: 700,
                                    padding: "1px 7px",
                                    background: "var(--app-tint-red)",
                                    color: "#B91C1C",
                                    border: "1px solid #FECACA",
                                    borderRadius: 999,
                                    letterSpacing: 0.4,
                                    fontFamily: "Inter",
                                  }}
                                >
                                  Narcotic
                                </span>
                              )}
                              <span
                                style={{
                                  fontSize: 9,
                                  fontWeight: 700,
                                  padding: "1px 7px",
                                  background: "var(--app-tint-purple)",
                                  color: "#6B21A8",
                                  border: "1px solid #E9D5FF",
                                  borderRadius: 999,
                                  letterSpacing: 0.4,
                                  fontFamily: "Inter",
                                }}
                              >
                                PRN
                              </span>
                            </div>
                            <span
                              style={{
                                fontSize: 12,
                                color: "var(--app-text-muted)",
                                fontFamily: "Inter",
                              }}
                            >
                              {[
                                selectedMedicine.ingestionMode,
                                selectedMedicine.dosageForm,
                              ]
                                .filter(Boolean)
                                .join(", ") || "—"}
                              {selectedMedicine.medicineRemaining != null &&
                              selectedMedicine.totalMedicine != null
                                ? ` · ${selectedMedicine.medicineRemaining} of ${selectedMedicine.totalMedicine} remaining`
                                : ""}
                            </span>
                          </div>
                        </div>

                        {/* Use / Instruction info row */}
                        <div className={classes.prnMedInfoRow}>
                          <Box style={{ flex: 1 }}>
                            <Text
                              size="xs"
                              weight={600}
                              style={{ color: "var(--app-text-muted)", fontFamily: "Inter" }}
                            >
                              Use of medication
                            </Text>
                            <Text
                              size="xs"
                              style={{
                                color: "var(--app-text-muted)",
                                fontFamily: "Inter",
                                marginTop: 4,
                              }}
                            >
                              {selectedMedicine.medicationUse || "—"}
                            </Text>
                          </Box>
                          <Box style={{ flex: 1 }}>
                            <Text
                              size="xs"
                              weight={600}
                              style={{ color: "var(--app-text-muted)", fontFamily: "Inter" }}
                            >
                              Medication Instruction
                            </Text>
                            <Text
                              size="xs"
                              style={{
                                color: "var(--app-text-muted)",
                                fontFamily: "Inter",
                                marginTop: 4,
                              }}
                            >
                              {selectedMedicine.medicationInstruction || "—"}
                            </Text>
                          </Box>
                        </div>
                      </>
                    )}
                  </div>

                  {/* ── Form fields — only shown after a medication is selected ── */}
                  {selectedMedicine && (
                    <div>
                      {/* Quantity + Staff in one row */}
                      <div className={classes.prnQtyStaffRow}>
                        {/* Quantity */}
                        <div style={{ flex: 1 }}>
                          <Text
                            size="sm"
                            weight={500}
                            mb={6}
                            style={{ color: "var(--app-text)", fontFamily: "Inter" }}
                          >
                            Quantity Dispensed
                          </Text>
                          <Flex className={classes.quantityRow}>
                            <ActionIcon
                              className={classes.qtyBtn}
                              variant="default"
                              onClick={() => {
                                const cur = Number(form.values.quantity) || 0;
                                if (cur > 0)
                                  form.setFieldValue(
                                    "quantity",
                                    String(cur - 1),
                                  );
                              }}
                            >
                              <TiMinus />
                            </ActionIcon>
                            <input
                              type="number"
                              value={form.values.quantity ?? ""}
                              onChange={(e) =>
                                form.setFieldValue("quantity", e.target.value)
                              }
                              onWheel={(e) => e.target.blur()}
                              className={classes.qtyInput}
                              placeholder="0"
                            />
                            <ActionIcon
                              className={classes.qtyBtn}
                              variant="default"
                              size={42}
                              onClick={() => {
                                const cur = Number(form.values.quantity) || 0;
                                form.setFieldValue("quantity", String(cur + 1));
                              }}
                            >
                              <FaPlus />
                            </ActionIcon>
                          </Flex>
                        </div>

                        {/* Staff */}
                        <div style={{ flex: 1 }}>
                          {profile?.user?.role !== "staff" ? (
                            <Select
                              className={classes.inputStyle}
                              data={populateStaff}
                              value={selectedStaff}
                              placeholder="Select Staff"
                              label="Select Staff"
                              onChange={(e) => setSelectedStaff(e)}
                              rightSection={<IconChevronDown size={16} />}
                              withinPortal={false}
                              dropdownPosition="bottom"
                              nothingFound="No staff found"
                            />
                          ) : (
                            <Text weight={600} ff="Inter" size="sm">
                              {profile?.user?.name}
                            </Text>
                          )}
                        </div>
                      </div>

                      {/* Reason */}
                      <Select
                        className={classes.inputStyle}
                        label="Reason for Administration"
                        data={[
                          { value: "Allergies", label: "Allergies" },
                          { value: "Headache", label: "Headache" },
                          { value: "Congestion", label: "Congestion" },
                          { value: "Cold/Flu", label: "Cold/Flu" },
                          { value: "Constipation", label: "Constipation" },
                          { value: "Cough", label: "Cough" },
                          { value: "Diarrhea", label: "Diarrhea" },
                          {
                            value: "Itchiness/Rash",
                            label: "Itchiness/Rash",
                          },
                          { value: "Fever", label: "Fever" },
                          { value: "Behavior", label: "Behavior" },
                          {
                            value: "Cuts/Abrasions",
                            label: "Cuts/Abrasions",
                          },
                          { value: "Pain", label: "Pain" },
                          { value: "Chafing", label: "Chafing" },
                          { value: "Hemorrhoids", label: "Hemorrhoids" },
                          { value: "Agitation", label: "Agitation" },
                          { value: "Blood Sugar", label: "Blood Sugar" },
                          {
                            value: "Blood Pressure",
                            label: "Blood Pressure",
                          },
                          {
                            value: "Anxiety and panic attacks",
                            label: "Anxiety and panic attacks",
                          },
                          {
                            value: "Nausea and vomiting",
                            label: "Nausea and vomiting",
                          },
                          {
                            value: "Sleep disturbances",
                            label: "Sleep disturbances",
                          },
                          {
                            value: "Asthma attacks",
                            label: "Asthma attacks",
                          },
                          {
                            value: "Allergic reactions",
                            label: "Allergic reactions",
                          },
                          {
                            value: "Migraine relief",
                            label: "Migraine relief",
                          },
                          { value: "Muscle spasms", label: "Muscle spasms" },
                          {
                            value: "Heartburn or acid reflux",
                            label: "Heartburn or acid reflux",
                          },
                          {
                            value: "Flare-ups of chronic conditions",
                            label: "Flare-ups of chronic conditions",
                          },
                          {
                            value: "Menstrual cramps",
                            label: "Menstrual cramps",
                          },
                          { value: "Infections", label: "Infections" },
                          {
                            value: "Dermatological conditions",
                            label: "Dermatological conditions",
                          },
                          { value: "Other", label: "Other" },
                        ]}
                        rightSection={<IoIosArrowDown />}
                        placeholder="Select Reason"
                        {...form.getInputProps("reason")}
                      />
                      {form.values.reason === "Other" && (
                        <Textarea
                          mt={12}
                          className={classes.inputStyle}
                          label="Other Reason"
                          placeholder="Enter other reason here"
                          {...form.getInputProps("otherReason")}
                        />
                      )}

                      {/* Comment */}
                      <Textarea
                        className={classes.inputStyle}
                        label="Comment"
                        mt={12}
                        minRows={5}
                        placeholder="Enter comment here"
                        {...form.getInputProps("comments")}
                      />

                      {/* Date / Time */}
                      <Flex gap="md" mt={12}>
                        <DatePickerInput
                          label="Administration Date"
                          placeholder="Pick a date"
                          value={
                            form.values.createdAt
                              ? new Date(form.values.createdAt)
                              : null
                          }
                          onChange={(newDate) => {
                            if (newDate) {
                              const dt = new Date(newDate);
                              const now = new Date();
                              if (form.values.createdAt) {
                                const existing = new Date(
                                  form.values.createdAt,
                                );
                                dt.setHours(
                                  existing.getHours(),
                                  existing.getMinutes(),
                                );
                              } else {
                                dt.setHours(now.getHours(), now.getMinutes());
                              }
                              form.setFieldValue("createdAt", dt);
                            } else {
                              form.setFieldValue("createdAt", null);
                            }
                          }}
                          maxDate={new Date()}
                          icon={<LuCalendar />}
                          clearable
                          className={classes.inputStyle}
                          style={{ flex: 1 }}
                        />
                        <TimeInput
                          label="Administration Time"
                          placeholder="Pick a time"
                          value={
                            form.values.createdAt
                              ? dayjs(form.values.createdAt).format("HH:mm")
                              : ""
                          }
                          onChange={(e) => {
                            const newTime = e.currentTarget.value;
                            if (newTime) {
                              const [hours, minutes] = newTime.split(":");
                              const dt = form.values.createdAt
                                ? new Date(form.values.createdAt)
                                : new Date();
                              dt.setHours(parseInt(hours), parseInt(minutes));
                              form.setFieldValue("createdAt", dt);
                            }
                          }}
                          icon={<IconClock />}
                          format="12"
                          withDropdown
                          className={classes.inputStyle}
                          style={{ flex: 1 }}
                        />
                      </Flex>
                    </div>
                  )}
                </div>
              </div>

              {/* Sticky footer */}
              <div className={classes.prnFooter}>
                <button
                  type="button"
                  className={classes.prnCancelBtn}
                  onClick={() => {
                    onclose();
                    setSelectedStaff();
                    setSelectedMedicine(null);
                    form.reset();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={!selectedMedicine}
                  className={classes.prnSaveBtn}
                >
                  {loading ? "Saving…" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </Drawer>

        {/* ── DRAWER: View existing PRN ── */}
        {!isNew && (
          <Drawer
            opened={opened && !isNew}
            onClose={() => {
              onclose();
              setIsEditOpen(false);
              setSelectedStaff();
              form.reset();
            }}
            closeOnClickOutside={false}
            offset={8}
            size={690}
            sx={{
              ".mantine-Drawer-close": {
                color: "var(--app-text)",
                "& svg": {
                  width: "25px !important",
                  height: "25px !important",
                },
              },
              ".mantine-Drawer-content": {
                background: "var(--app-surface)",
                borderTopLeftRadius: 16,
                borderBottomLeftRadius: 16,
              },
              ".mantine-Drawer-body": {
                padding: 0,
                height: "100%",
                // overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              },
            }}
            zIndex={2000}
            position="right"
            overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}
            shadow="md"
            title={
              <Text fz={24} fw={700} ff="Inter" color="var(--app-text)">
                Medication
              </Text>
            }
          >
            <div className={classes.drawerBody}>
              {/* Header */}
              {/* Scrollable body */}
              <div className={classes.formBox}>
                <div className={classes.prnWrapper}>
                  {/* Client card */}
                  <div className={classes.viewClientCard}>
                    <Flex align="center" gap={12}>
                      <Avatar
                        className={classes.clientAvatar}
                        src={decrypt(selectedClient?.imageurl) || ""}
                        alt="client"
                        radius="xl"
                        size={48}
                      />
                      <div>
                        <Text className={classes.clientName}>
                          {selectedClient?.name}
                        </Text>
                        <Text className={classes.clientId}>
                          {selectedClient?.id?.slice(0, 6)?.toLowerCase()}
                        </Text>
                      </div>
                    </Flex>
                  </div>

                  {/* Medication info card */}

                  <div className={classes.medicineCard}>
                    <DeleteComponent
                      data={state}
                      onClose={onclose}
                      type={"prn"}
                    />
                    <Box className={classes.medicineDetailsCard}>
                      <Box className={classes.medicineInnerCard}>
                        <span className={classes.prnBadge}>PRN</span>

                        {/* Freq | Unlimited/remaining */}
                        <Flex className={classes.medFreqAndCountRow}>
                          <Box className="freqAndTime">
                            <p className="frequency">
                              {selectedMedicine?.frequency}
                            </p>
                            <p className="time">
                              {moment(state?.createdAt)?.format("hh:mm A")}
                            </p>
                          </Box>
                          {selectedMedicine?.totalMedicine === "unlimited" ||
                          state?.medicineRemaining === "unlimited" ? (
                            <span className={classes.unlimitedBadge}>
                              Unlimited
                            </span>
                          ) : (
                            <Box className="freqAndTime">
                              <p className="frequency">
                                {state?.medicineRemaining ?? "—"}
                              </p>
                              <p className="time">
                                of {state?.totalMedicine} Remaining
                              </p>
                            </Box>
                          )}
                        </Flex>

                        {/* Med name + narcotic | Qty dispensed */}
                        <Flex className={classes.quantityAndInfoRow}>
                          <Box>
                            <Flex align="center" gap={6}>
                              <p className="name">
                                {selectedMedicine?.medicationName}
                                {selectedMedicine?.dosage
                                  ? ` (${selectedMedicine.dosage}${selectedMedicine.unit || ""})`
                                  : ""}
                              </p>
                              {selectedMedicine?.isNarcotic === "Yes" && (
                                <span className={classes.narcoticBadge}>
                                  Narcotic
                                </span>
                              )}
                            </Flex>
                            <p className="dosage">
                              {[
                                selectedMedicine?.ingestionMode,
                                selectedMedicine?.dosageForm,
                              ]
                                .filter(Boolean)
                                .join(" ")}
                            </p>
                          </Box>
                          <Box className={classes.viewQtyBox}>
                            <p className={classes.viewQtyNumber}>
                              {state?.dosage ?? "—"}
                            </p>
                            <p className={classes.viewQtyLabel}>
                              Quantity Dispensed
                            </p>
                          </Box>
                        </Flex>

                        {/* Use of medication | Medication Instruction */}
                        <div className={classes.viewInfoBox}>
                          <Flex className={classes.viewInfoRow}>
                            <Box>
                              <p className={classes.viewInfoLabel}>
                                Use of medication
                              </p>
                              <p className={classes.viewInfoValue}>
                                {selectedMedicine?.medicationUse || "N/A"}
                              </p>
                            </Box>
                            <Box>
                              <p className={classes.viewInfoLabel}>
                                Medication Instruction
                              </p>
                              <p className={classes.viewInfoValue}>
                                {selectedMedicine?.medicationInstruction ||
                                  "N/A"}
                              </p>
                            </Box>
                          </Flex>
                        </div>

                        {/* Reason */}
                        <div className={classes.reasonSection}>
                          <p className={classes.reasonLabel}>
                            Reason for administration
                          </p>
                          <p className={classes.reasonValue}>
                            {state?.reason || "—"}
                          </p>
                        </div>
                      </Box>
                    </Box>

                    {/* Comment (read-only) */}
                    <Textarea
                      className={classes.inputStyle}
                      label="Comment"
                      minRows={4}
                      value={form.values.comments || ""}
                      readOnly
                      disabled
                    />

                    {/* Medication details card — view mode */}
                    {!isEditOpen && (
                      <div className={classes.medDetailsCard}>
                        <Flex justify="space-between" align="center" mb={12}>
                          <p className={classes.medDetailsTitle}>
                            Medication details
                          </p>
                          {userType !== "staff" && (
                            <Button
                              className={classes.editBtnOrange}
                              onClick={() => {
                                form.setFieldValue(
                                  "date",
                                  prnAdministeredAt
                                    ? new Date(prnAdministeredAt)
                                    : new Date(),
                                );
                                form.setFieldValue(
                                  "time",
                                  prnAdministeredAt
                                    ? moment(prnAdministeredAt).format("HH:mm")
                                    : moment().format("HH:mm"),
                                );
                                setIsEditOpen(true);
                              }}
                            >
                              Edit
                            </Button>
                          )}
                        </Flex>
                        <div className={classes.medDetailsInner}>
                          <div className={classes.medDetailsCol}>
                            <p className={classes.medDetailsLabel}>
                              Administered by
                            </p>
                            <p className={classes.medDetailsValue}>
                              {state?.staff?.name || "—"}
                            </p>
                          </div>
                          <div className={classes.medDetailsCol}>
                            <p className={classes.medDetailsLabel}>Signature</p>
                            {staffSignature?.signature ||
                            staffSignature?.signatureImage ? (
                              <img
                                className={classes.medDetailsSigImg}
                                src={
                                  decrypt(staffSignature?.signature) ||
                                  decrypt(staffSignature?.signatureImage)
                                }
                                alt="signature"
                              />
                            ) : staffSignature?.signatureText ? (
                              <p className={classes.medDetailsSigText}>
                                {staffSignature?.signatureText}
                              </p>
                            ) : (
                              <p className={classes.medDetailsValue}>—</p>
                            )}
                          </div>
                          <div className={classes.medDetailsCol}>
                            <p className={classes.medDetailsLabel}>Date</p>
                            <p className={classes.medDetailsValue}>
                              {prnAdministeredAt
                                ? moment(prnAdministeredAt).format("MM/DD/YYYY")
                                : "—"}
                            </p>
                          </div>
                          <div className={classes.medDetailsCol}>
                            <p className={classes.medDetailsLabel}>Time</p>
                            <p className={classes.medDetailsValue}>
                              {prnAdministeredAt
                                ? moment
                                    .tz(
                                      moment(prnAdministeredAt),
                                      profile?.user?.timeZone,
                                    )
                                    .format("hh:mm a")
                                : "—"}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Medication details card — edit mode */}
                    {isEditOpen && (
                      <form
                        onSubmit={form?.onSubmit((values) =>
                          handleAdminBy(values),
                        )}
                      >
                        <div className={classes.medDetailsCard}>
                          <Flex justify="space-between" align="center" mb={12}>
                            <p className={classes.medDetailsTitle}>
                              Medication details
                            </p>
                            <Flex gap={8}>
                              <Button
                                className={classes.cancelBtn}
                                onClick={() => setIsEditOpen(false)}
                              >
                                Cancel
                              </Button>
                              {userType !== "staff" && (
                                <Button
                                  loading={btnLoading}
                                  type="submit"
                                  className={classes.editBtnOrange}
                                >
                                  Save
                                </Button>
                              )}
                            </Flex>
                          </Flex>
                          <div className={classes.medDetailsInner}>
                            <div className={classes.editDetailsGrid}>
                              {/* Select Staff */}
                              <div className={classes.medDetailsCol}>
                                {userType !== "staff" ? (
                                  <Select
                                    label="Select Staff"
                                    className={classes.inputStyle}
                                    data={populateStaff?.map((d) => ({
                                      value: d.value,
                                      label: d.label,
                                    }))}
                                    placeholder="Select Staff"
                                    {...form.getInputProps("staff")}
                                    rightSection={<IconChevronDown />}
                                    withinPortal={false}
                                  />
                                ) : (
                                  <p className={classes.medDetailsValue}>
                                    {state?.staff?.name}
                                  </p>
                                )}
                              </div>
                              {/* Signature */}
                              <div className={classes.medDetailsCol}>
                                <p className={classes.labelStyle}>Signature</p>
                                <div className={classes.sigBox}>
                                  {staffSignature?.signature ||
                                  staffSignature?.signatureImage ? (
                                    <img
                                      className={classes.medDetailsSigImg}
                                      src={
                                        decrypt(staffSignature?.signature) ||
                                        decrypt(staffSignature?.signatureImage)
                                      }
                                      alt="signature"
                                    />
                                  ) : staffSignature?.signatureText ? (
                                    <p className={classes.medDetailsSigText}>
                                      {staffSignature?.signatureText}
                                    </p>
                                  ) : (
                                    <p className={classes.medDetailsValue}>—</p>
                                  )}
                                </div>
                              </div>
                              {/* Select Date */}
                              <div className={classes.medDetailsCol}>
                                {userType !== "staff" ? (
                                  <DateInput
                                    label="Select date"
                                    className={classes.inputStyle}
                                    placeholder="Pick a date"
                                    icon={<LuCalendar size={16} />}
                                    classNames={{
                                      icon: classes.timeInputLeftIcon,
                                    }}
                                    {...form.getInputProps("date")}
                                    onChange={(val) => {
                                      form.setFieldValue("date", val);
                                      if (val) {
                                        form.setFieldValue(
                                          "time",
                                          moment().format("HH:mm"),
                                        );
                                      }
                                    }}
                                  />
                                ) : (
                                  <p className={classes.medDetailsValue}>
                                    {moment(state?.createdAt).format(
                                      "MM/DD/YYYY",
                                    )}
                                  </p>
                                )}
                              </div>
                              {/* Select Time */}
                              <div className={classes.medDetailsCol}>
                                {userType !== "staff" ? (
                                  <TimeInput
                                    className={classes.inputStyle}
                                    ref={timeRef}
                                    label="Select time"
                                    icon={
                                      <ActionIcon
                                        variant="subtle"
                                        color="gray"
                                        onClick={() =>
                                          timeRef?.current?.showPicker()
                                        }
                                      >
                                        <IconClock
                                          style={{
                                            width: rem(16),
                                            height: rem(16),
                                          }}
                                          stroke={1.5}
                                        />
                                      </ActionIcon>
                                    }
                                    classNames={{
                                      icon: classes.timeInputLeftIcon,
                                    }}
                                    {...form.getInputProps("time")}
                                  />
                                ) : (
                                  <p className={classes.medDetailsValue}>
                                    {moment
                                      .tz(
                                        moment(state?.createdAt),
                                        profile?.user?.timeZone,
                                      )
                                      .format("hh:mm a")}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    )}

                    {/* Was the medication effective? */}
                    <form
                      onSubmit={form2?.onSubmit((values) =>
                        onSavePress(values),
                      )}
                    >
                      <Accordion
                        variant="contained"
                        mt={16}
                        sx={{ marginBottom: "20px" }}
                      >
                        <Accordion.Item
                          value="effective"
                          className={classes.accordionSelectItem}
                        >
                          <Accordion.Control
                            className={classes.accordionSelectControl}
                          >
                            Was the medication effective?
                          </Accordion.Control>
                          <Accordion.Panel>
                            <div className={classes.effectiveRadioPanel}>
                              <Radio.Group
                                defaultValue={form2?.values.wasEffective}
                                {...form2.getInputProps("wasEffective")}
                                required
                              >
                                <Flex gap={32}>
                                  <Radio
                                    disabled={
                                      state?.medicationType?.[0]
                                        ?.wasMedicineEffective &&
                                      state?.medicationType?.[0]
                                        ?.wasMedicineEffective !== ""
                                    }
                                    value="Yes"
                                    label="Yes"
                                  />
                                  <Radio
                                    disabled={
                                      state?.medicationType?.[0]
                                        ?.wasMedicineEffective &&
                                      state?.medicationType?.[0]
                                        ?.wasMedicineEffective !== ""
                                    }
                                    value="No"
                                    label="No"
                                  />
                                </Flex>
                              </Radio.Group>
                            </div>
                          </Accordion.Panel>
                        </Accordion.Item>
                      </Accordion>

                      <Button
                        loading={loadingResponse}
                        type="submit"
                        fullWidth
                        disabled={
                          state?.medicationType?.[0]?.wasMedicineEffective &&
                          state?.medicationType?.[0]?.wasMedicineEffective !==
                            ""
                        }
                        className={classes.prnSaveBtn}
                      >
                        Save
                      </Button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        )}
      </>
    );
  },
);

export default PRNMedicationModal;
